<div class="mt">
  <p class="text">47.{{ Texts.otherPerson }}</p>
  <div class="row">
    <ng-container [formGroup]="personForm">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.nameLabel }}</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>

      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>Tipo de relacion *</mat-label>
          <!-- <input type="text" matInput formControlName="relation" />realtion -->
          <mat-select formControlName="relation">
            <mat-option *ngFor="let relat of relation" [value]="relat">
              {{ relat }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.nIdentification }} </mat-label>
          <mat-select formControlName="nationality">
            <mat-option *ngFor="let doc of document" [value]="doc">
              {{ doc }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>Documento de identidad *</mat-label>
          <input type="text" matInput formControlName="document" />
        </mat-form-field>
      </div>

      <div class="col-12 buttons">
        <button
          *ngIf="editing == null"
          class="primary-btn rounded"
          [disabled]="personForm.invalid"
          mat-raised-button
          (click)="add()"
        >
          Agregar
        </button>
        <ng-container *ngIf="editing != null">
          <button
            class="cancel-btn rounded"
            mat-raised-button
            (click)="cancelEdit()"
          >
            Cancelar
          </button>
          <button
            class="primary-btn rounded"
            [disabled]="personForm.invalid"
            mat-raised-button
            (click)="edit()"
          >
            Editar
          </button>
        </ng-container>
      </div>
    </ng-container>
    <div class="col-12">
      <table mat-table [dataSource]="dataSource">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            Nombre y apellido / Razón social
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Weight Column -->

        <ng-container matColumnDef="nationality">
          <th mat-header-cell *matHeaderCellDef>Nacionalidad</th>
          <td mat-cell *matCellDef="let element">{{ element.nationality }}</td>
        </ng-container>

        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef>Documento de identidad</th>
          <td mat-cell *matCellDef="let element">{{ element.document }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="relation">
          <th mat-header-cell *matHeaderCellDef>Tipo de relacion</th>
          <td mat-cell *matCellDef="let element">{{ element.relation }}</td>
        </ng-container>
        <!-- Symbol Column -->
        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef>Opciones</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <div class="options">
              <mat-icon class="edit" (click)="setToEdit(i)">edit</mat-icon>
              <mat-icon class="delete" (click)="delete(i)">delete</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
